import * as types from '../types'
import _ from 'lodash'
// state
const company_info = {

  supay: {
    companyName: 'Simpay.',
    url: '',
    copyRight: '',
    baseTitle: ' | Simpay Merchant Console',
    phone: '',
    email: '',
    welcome: 'Welcome to use Simpay!',
    currency: 'F$',
    international: false,
    utcOffset: '+10:00',
    timeZone: 'Australia/Sydney'

  }
}

const state = {
  name: COMPANY_NAME,
  companyInfo: _.pick(company_info, COMPANY_NAME)[COMPANY_NAME]
}

const mutations = {
  [types.CHANGETHEME](state, themeName) {
    state.name = themeName
    state.companyInfo = _.pick(company_info, themeName)[themeName]
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js